const state = {
    depositAmount: 0,
    walletHistory: null,
    userTransactionStakes: null,
    selectedPayementType:null
};
const getters = {
    depositAmount:state => state?.depositAmount,
    walletHistory: state => state?.walletHistory,
    userTransactionStakes: state => state?.userTransactionStakes,
    selectedPayementType: state => state?.selectedPayementType,

};
const actions = {
    setDepositAmount({ commit }, depositAmount) {
        commit('setDepositAmount', depositAmount);
    },
    setWalletHistoryData({ commit }, walletHistory) {
        commit('setWalletHistoryData', walletHistory);
    },
    setUserTransactionStakes({ commit }, userTransactionStakes) {
        commit('setUserTransactionStakes', userTransactionStakes);
    },
    setSelectedPayementAcc({ commit }, filter) {
        commit('setSelectedPayementAcc', filter);
    },
};
const mutations = {
    setDepositAmount(state, depositAmount){
        state.depositAmount =  depositAmount
    },
    setWalletHistoryData(state, walletHistory) {
        state.walletHistory = walletHistory;
    },
    setUserTransactionStakes(state, userTransactionStakes) {
        state.userTransactionStakes = userTransactionStakes;
    },
    setSelectedPayementAcc(state, selectedPayementType) {
        state.selectedPayementType = selectedPayementType;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};